import { useCallback } from 'react';

import { reportTraitIssue } from '../../../services/traits.js';
import { useReportItemIssue } from './useReportItemIssue.js';

const TRAIT_REPORT_TOASTS = Object.freeze({
  successTitle: 'intelligence.traits.detail.toast.reportedTitle',
  successMessage: 'intelligence.traits.detail.toast.reportedMessage',
  errorTitle: 'intelligence.traits.detail.toast.reportErrorTitle',
  errorMessage: 'intelligence.traits.detail.toast.reportErrorMessage',
});

/**
 * "Report an issue" on a trait (CT-5715). The rules — one request per double
 * click, toasts, final after a success — are `useReportItemIssue`'s.
 *
 * @param {object} options
 * @param {string} options.entityType
 * @param {string} options.entityId
 * @param {string} options.traitId
 * @param {() => void} [options.onReported] — re-read the trait, quietly.
 * @param {() => void} [options.onChanged] — tell the page it changed (CT-5714).
 */
export function useReportTraitIssue({ entityType, entityId, traitId, onReported, onChanged } = {}) {
  // The service is read at call time, not captured, so a test can spy on it.
  const send = useCallback(() => reportTraitIssue({ entityType, entityId, traitId }), [entityType, entityId, traitId]);
  return useReportItemIssue({ send, toastKeys: TRAIT_REPORT_TOASTS, onReported, onChanged });
}

export default useReportTraitIssue;
